import { format } from 'owa-localize';
import { makeDeleteRequest } from 'owa-ows-gateway';

const removeConnectedAccountUrl: string = 'ows/beta/ConnectedAccounts/{0}';

export async function removeConnectedAccount(id: string): Promise<Response> {
    return await makeDeleteRequest(
        format(removeConnectedAccountUrl, id),
        undefined,
        undefined,
        true
    );
}
